const doc = [({"en":({"js":({"merfoto":({"layout":({"topbar":({"index":({"basket":"Basket"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;